import React from "react";

export default function About() {
  return (
    <>
      <section className="page-hero about-page">
        <p className="eyebrow">About Fairview CM</p>
        <h1>Practical warehouse labor management for container-heavy operations.</h1>
        <p>
          Fairview Container Management supports warehouses, importers, 3PLs,
          retailers, and distribution teams that need dependable hands on the dock.
          Our work is focused on container destuffing, lumping crews, palletizing,
          wrapping, sorting, staging, and cross-dock support across the GTA and
          Southern Ontario.
        </p>
        <p>
          Container unloading is more than moving cartons out of a trailer. The
          work has to protect freight, keep dock flow organized, separate SKUs
          accurately, build stable pallets, and hand the load back to the warehouse
          in a condition that is ready for receiving, storage, rework, or outbound
          movement.
        </p>
      </section>

      <section className="about-detail">
        <div>
          <p className="eyebrow">How We Work</p>
          <h2>Crews planned around the reality of your dock.</h2>
        </div>
        <div className="about-copy">
          <p>
            Every job starts with the basics that matter on the floor: container
            size, freight type, carton condition, SKU mix, pallet requirements,
            available dock space, and the turnaround target. From there, Fairview
            assigns the right crew size and keeps the work organized from first
            carton to final staged pallet.
          </p>
          <p>
            Our role is to reduce friction for your warehouse team. We unload
            floor-loaded containers, sort freight as required, identify visible
            damage or unstable loads, rebuild pallets, wrap finished units, and
            stage freight where your receiving or shipping process needs it.
          </p>
        </div>
      </section>

      <section className="section about-section">
        <div className="section-heading">
          <p className="eyebrow">What Matters</p>
          <h2>Focused on speed, accuracy, and a cleaner handoff.</h2>
        </div>
        <div className="values-grid">
          <article>
            <h2>Reliable crews</h2>
            <p>Staffing is planned around arrival windows, dock capacity, freight profile, and required turnaround.</p>
          </article>
          <article>
            <h2>Careful handling</h2>
            <p>Crews work with attention to carton condition, product separation, pallet stability, and site-specific handling rules.</p>
          </article>
          <article>
            <h2>Clear handoff</h2>
            <p>Finished freight is staged, wrapped, labelled, or reworked so the next warehouse step is easier.</p>
          </article>
          <article>
            <h2>Flexible support</h2>
            <p>Fairview can support scheduled inbound programs, seasonal spikes, one-off unloads, and recurring warehouse labor needs.</p>
          </article>
          <article>
            <h2>Supervisor mindset</h2>
            <p>Work is organized around communication, visible progress, and practical decisions when freight does not arrive as expected.</p>
          </article>
          <article>
            <h2>Safety first</h2>
            <p>Crews are expected to respect site rules, dock flow, equipment boundaries, and safe manual handling practices.</p>
          </article>
        </div>
      </section>

      <section className="about-detail about-detail-alt">
        <div>
          <p className="eyebrow">Why Warehouses Call Fairview</p>
          <h2>Extra labor when freight volume outpaces the plan.</h2>
        </div>
        <div className="about-checklist">
          <span>20 ft, 40 ft, high-cube, and trailer unload support</span>
          <span>Floor-loaded cartons, mixed SKUs, and irregular freight profiles</span>
          <span>Palletizing, shrink wrapping, labelling, and staging</span>
          <span>Cross-dock, reload, restack, and load correction work</span>
          <span>Support for importers, retailers, 3PLs, and distribution centers</span>
        </div>
      </section>
    </>
  );
}
